<style type="text/css" media="print">
  @page { size: portrait; }
</style>

<div class="only-print page-break" id="print-aplicacao-{{application.id}}">
  <img ng-src="{{$root.parametros.imagem_report_url}}" ng-if="$root.parametros.imagem_report_url" class="logo">
  <div class="title-recomendacoes">
    {{::application.allData.operacao.descricao | capitalize}}
  </div>
  <br>
  <p>
    <strong>Iniciada em: </strong>
    {{::application.allData.atributo.iniciado_em | date: 'dd/MM/yyyy HH:mm'}}
    <br>
    <strong>Encerrada em: </strong>
    {{::application.allData.atributo.encerrado_em | date: 'dd/MM/yyyy HH:mm'}}
    <br>
  </p>
  <strong>Propriedade: </strong>{{::application.allData.propriedade.descricao | uppercase}}
  <br>
  <strong>Talhão: </strong>{{::application.gleba.descricao | uppercase}} ({{::application.gleba.area_total | number:1}} ha)
  <span class="side-space"></span>
  <strong>Cultura: </strong>{{::application.allData.atividade.descricao | uppercase}}

  <table class="table no-padding recomendacao">
    <thead>
      <tr>
        <th class="no-padding-left">Produto</th>
        <th class="text-right">Dose</th>
        <th class="text-right">Total</th>
        <th class="text-right" ng-if="application.someHasLote">Lote</th>
        <th class="text-right" ng-if="application.someHasLote">Carência</th>
      </tr>
    </thead>
    <tbody>
      <tr ng-repeat="produto in application.allData.itens">
        <td class="no-padding-left vertical-middle">{{::produto.descricao}}</td>
        <td class="text-right">{{produto.qt_dose | formatDynamicDecimals}} {{::produto.unidade.abreviatura}}/ha</td>
        <td class="text-right">{{produto.qt_total | formatDynamicDecimals}} {{::produto.unidade.abreviatura}}</td>
        <td class="text-right" ng-if="application.someHasLote">{{::produto.nr_lote}}</td>
        <td ng-if="application.someHasLote" class="text-right">{{::produto.carencia_residual_dias}}</td>
      </tr>
    </tbody>
  </table>

  <p
    class="list-group-item-text"
    ng-show="application.infosCultivares"
    ng-repeat="infoCultivar in application.infosCultivares"
    ng-if="!!infoCultivar.data_emergencia"
  >
    <strong>{{::infoCultivar.descricao}}</strong>
    <br>
    <strong>Data de emergência: </strong>
    {{::infoCultivar.data_emergencia | date: 'dd/MM/yyyy'}}
    <br>
    <strong>Data estimada de colheita:</strong>
    {{::infoCultivar.data_estimada_colheita | date: 'dd/MM/yyyy'}}
    <br>
    <span ng-if="infoCultivar.dias_da_emergencia > 0">
      Aplicação realizada <strong>{{::infoCultivar.dias_da_emergencia}}</strong> dias após emergência
    </span>
    <span ng-if="infoCultivar.dias_da_emergencia < 0">
      Aplicação realizada <strong>{{::infoCultivar.dias_da_emergencia * -1}}</strong> dias antes da emergência
    </span>
    <span ng-if="infoCultivar.dias_da_emergencia === 0">
      Aplicação realizada no dia da emergência
    </span>
  </p>
  <p class="list-group-item-text">
    <strong>Área Total: </strong>{{::application.area | number:1}} ha
  </p>
  <p class="list-group-item-text" ng-show="application.allData.atributo.capacidade_tanque">
    <strong>Capacidade Tanque: </strong>{{::application.allData.atributo.capacidade_tanque | number:2}} l
  </p>
  <p class="list-group-item-text" ng-show="application.allData.atributo.velocidade_maxima_vento">
    <strong>Vento: </strong>{{::application.allData.atributo.velocidade_maxima_vento | number:0}} km/h
  </p>
  <p class="list-group-item-text" ng-show="application.allData.atributo.umidade_inicial">
    <span ng-show="application.allData.atributo.umidade_inicial">
      <strong>Umidade: </strong>{{::application.allData.atributo.umidade_inicial | number:0}}%
    </span>
  </p>
  <p class="list-group-item-text" ng-show="application.allData.atributo.temperatura_inicial">
    <span ng-show="application.allData.atributo.temperatura_inicial">
      <strong>Temperatura: </strong>{{::application.allData.atributo.temperatura_inicial | number:0}}°C
    </span>
  </p>
  <p class="list-group-item-text" ng-show="application.allData.atributo.horas_sem_chuva">
    <strong>{{::application.allData.atributo.horas_sem_chuva | number:0}} horas</strong> sem chuva
  </p>
  <p class="list-group-item-text" ng-show="application.allData.obs">
    <strong>Observação: </strong> {{::application.allData.obs}}
  </p>

  <div class="signatures">
    <print-signature label="Recomendante" name="application.recommendation.recomendante.nome_completo"></print-signature>
    <print-signature label="Responsável"></print-signature>
    <print-signature label="Aplicador" name="application.allData.usuario.nome_completo"></print-signature>
  </div>
</div>
